<template>
	<nut-dialog
		teleport="body"
		title="设备状态"
		:visible="modelValue"
		ok-text="关闭"
		@ok="hanldleClose"
		no-cancel-btn
	>
		<div class="row">
			<span class="label">在线状态：</span>
			<span
				class=""
				:class="[
					'val',
					deviceData.Status === 'offline' ? 'val-off' : 'val-on',
				]"
				>{{ deviceData.Status === 'offline' ? '离线' : '在线' }}</span
			>
		</div>
		<div class="row">
			<span class="label">存储总空间(MB)：</span>
			<span class="val">{{ deviceData.TotalSize }}</span>
		</div>
		<div class="row">
			<span class="label">剩余空间(MB)：</span>
			<span class="val">{{ deviceData.LeftSize }}</span>
		</div>
		<div class="row">
			<span class="label">未执行任务数：</span>
			<span class="val">{{ deviceData.TaskCount }}</span>
		</div>
	</nut-dialog>
</template>

<script>
export default {
	name: 'DeviceStatus',
	props: {
		modelValue: {
			type: Boolean,
			required: true,
		},
		deviceData: {
			type: Object,
			required: true,
		},
	},
	emits: ['update:modelValue'],
	setup(props, { emit }) {
		const hanldleClose = () => {
			emit('update:modelValue', false);
		};
		return {
			hanldleClose,
		};
	},
};
</script>

<style lang="scss" scoped>
.row {
	@include flex-center;
	line-height: 28px;
	font-size: $normal-font-size;

	.val-off {
		font-weight: 500;
		color: $error-color;
	}
	.val-on {
		font-weight: 500;
		color: #07c160;
	}
}
</style>
